// extracted by mini-css-extract-plugin
module.exports = {"root":"_3sI6B","largePadding":"_2S9Kn"};